import { platformApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpsertSharedMissingPerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ code, ...json }) => {
      if (code) {
        return platformApi
          .patch(`shared-missing-persons/${code}`, { json })
          .json();
      } else {
        return platformApi.post('shared-missing-persons', { json }).json();
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['sharedMissingPersons'] }),
  });
}
